import { Component, Input, ViewChild, ElementRef, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { Individual } from "src/app/parametrage/core/model/individual/individual";
import { IndividualService } from "src/app/parametrage/core/service/individual.service";
import { UpdateEmploiIndividual } from "src/app/parametrage/core/model/individual/update-emploi-individual";
import { Employeur } from "src/app/parametrage/core/model/employeur";
import { EmployeurService } from "src/app/parametrage/core/service/employeur.service";

@Component({
  selector: "app-update-emploi-individual",
  templateUrl: "./update-emploi-individual.component.html",
  styleUrls: ["./update-emploi-individual.component.scss"],
})
export class UpdateEmploiIndividualComponent implements OnInit {
  @Input() individualId;

  individual: Individual;

  customer: UpdateEmploiIndividual = new UpdateEmploiIndividual();

  employeurs: Employeur[];

  dateEmbaucheJson: any;

  form2: FormGroup;
  pressButton: Boolean = false;
  errorMessage: String = null;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _individualService: IndividualService,
    private _employeurService: EmployeurService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      employerName: [null, Validators.compose([Validators.nullValidator])],
      employeur: [null, Validators.compose([Validators.required])],
      employerAdresse: [null, Validators.compose([Validators.nullValidator])],
      dateEmbauche: ["", Validators.compose([Validators.nullValidator])],
      ancienneteEmploi: [
        "",
        [
          Validators.compose([Validators.nullValidator]),
          Validators.pattern("^-?[0-9]\\d*(\\.\\d*)?$"),
        ],
      ],
      profession: [null, Validators.compose([Validators.nullValidator])],
      fonctionDansEntreprise: [
        null,
        Validators.compose([Validators.nullValidator]),
      ],
      workPhone: [null, Validators.compose([Validators.nullValidator])],
    });
  }

  ngOnInit() {
    this.getAllEmployeur();
    this.getIndividualById(this.individualId);
  }

  getAllEmployeur() {
    this._employeurService.getAllEmployeurs().subscribe(
      (data) => {
        this.employeurs = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getIndividualById(individualId) {
    this._individualService.getIndividualById(individualId).subscribe(
      (data) => {
        this.individual = data;
        this.customer.individualId = this.individual.id;
        this.customer.employerName = this.individual.employerName;
        this.customer.employeur = this.individual.employeur;
        this.customer.employerAdresse = this.individual.employerAdresse;
        //this.customer.dateEmbauche = this.individual.dateEmbauche;
        this.dateEmbaucheJson = this.convertDateStringToDateJson(
          this.individual.dateEmbauche
        );
        this.customer.ancienneteEmploi = this.individual.ancienneteEmploi;
        this.customer.profession = this.individual.profession;
        this.customer.fonctionDansEntreprise =
          this.individual.fonctionDansEntreprise;
        this.customer.workPhone = this.individual.workPhone;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  update(): void {
    this.spinner.show();
    this.customer.dateEmbauche =
      this.convertDateJsonToDateString(this.dateEmbaucheJson, {
        hour: 0,
        minute: 0,
      }) + ":00Z";
    this._individualService
      .updateEmploi(this.customer)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          this.errorMessage = error.error.message;
          console.log(error);
          this.spinner.hide();
        }
      );
  }

  convertDateStringToDateJson(date: string) {
    let dateSimple = new Date(date);
    let dateJson = {
      year: dateSimple.getFullYear(),
      month: dateSimple.getMonth() + 1,
      day: dateSimple.getDate(),
    };
    return dateJson;
  }

  convertDateJsonToDateString(date, time) {
    let month;
    month = date.month;
    if (date.month < 10) {
      month = "0" + date.month;
    }

    let day;
    day = date.day;
    if (date.day < 10) {
      day = "0" + date.day;
    }

    //

    let hour;
    hour = time.hour;
    if (time.hour < 10) {
      hour = "0" + time.hour;
    }

    let minute;
    minute = time.minute;
    if (time.minute < 10) {
      minute = "0" + time.minute;
    }

    let datetime =
      date.year + "-" + month + "-" + day + "T" + hour + ":" + minute;
    return datetime;
  }
}
